export enum RoleTypeEnum {
  CREATIVE = 1,
  RUNNER = 5,
  SUPER_ADMIN = 10,
}
